import styled from 'styled-components';

export const CardsWrapper = styled.div`
  gap: 28px;
  padding-bottom: 48px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 32px;
  width: 100%;
  padding: 32px 24px 24px 32px;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
`;

export const IconWrapper = styled.div`
  border-radius: 50%;
  width: 80px;
  height: 80px;
  padding: 20px;
  background-color: ${(props) => props.theme.colors.iconBg};

  @media ${(props) => props.theme.device.mobileL} {
    width: 52px;
    height: 52px;
    padding: 13px;
  }
`;
